import { render, staticRenderFns } from "./DrugIssueRep.vue?vue&type=template&id=1167afff&"
import script from "./DrugIssueRep.vue?vue&type=script&lang=js&"
export * from "./DrugIssueRep.vue?vue&type=script&lang=js&"
import style0 from "./DrugIssueRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports